import { useEffect, useRef, useState, ReactNode } from "react";
import { extractTextFromNode } from "./extractTextFromNod";

export function useWordAnimation(
  text: string | ReactNode,
  options?: IntersectionObserverInit
) {
  const ref = useRef<HTMLSpanElement | null>(null);
  const [isVisible, setIsVisible] = useState(false);
  const [words, setWords] = useState<string[]>([]);

  useEffect(() => {
    const plainText = extractTextFromNode(text);
    const splitWords = plainText.split(" ").map((word, index, arr) =>
      index < arr.length - 1 ? word + "\u00A0" : word
    );
    setWords(splitWords);
  }, [text]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.3, ...options }
    );

    if (ref.current) observer.observe(ref.current);

    return () => observer.disconnect();
  }, [options]);

  return { ref, words, isVisible };
}
